<!-- 未识别到图片信息 -->
<template>
  <div v-if="onShow" class="noidentify-pop">
    <div class="contentPop">
      <h3 class="tips">提示</h3>
      <p class="font">系统未识别到，请上传正确的图片</p>
      <div class="know" @click="onClose">我知道了</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    onShow: Boolean,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onClose() {
      this.$emit('changeShow');
    },
  },
};
</script>
<style scoped lang="scss">
.noidentify-pop {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  .contentPop {
    position: relative;
    width: 634px;
    background: #ffffff;
    border-radius: 36px;
    padding: 50px 0 60px;
    margin: 0 auto;
    top: 50%;
    transform: translateY(-50%);
    .tips {
      font-weight: 500;
      font-size: 33px;
      color: #333333;
      text-align: center;
    
    }
    .font {
      font-weight: 400;
      font-size: 29px;
      color: #333333;
      text-align: center;
      margin-top: 30px;
      margin-block: 90px;
    }
    .know {
      width: 324px;
      height: 76px;
      line-height: 76px;
      background: #ff7f41;
      border-radius: 50px;
      margin: 0 auto;
      font-size: 32px;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
    }
  }
}
</style>
